import React from 'react';
import './Chapters.scss';

function Chapter4() {
  return (
    <section className="chapter">
      <p className="chapter__paragraph">
        AiSCOUT has reinvented the scouting process with motion tracking and artificial
        intelligence, making it more scientific—so that talented players anywhere have an equal
        opportunity to get noticed, develop, and rise to the top. Amateur athletes download the free
        AiSCOUT player app on their mobile phones, then they use the phone’s camera to record
        themselves performing certain drills that generate performance data that is benchmarked
        against world-class athletes.
      </p>
    </section>
  );
}

export default Chapter4;
